import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstLetterUpperCase',
  pure: false,
  standalone: true,
})
export class FirstLetterUpperCasePipe implements PipeTransform {
  transform(value: string): string {
    const _value = value.split('');
    _value[0] = _value[0].toUpperCase();
    return _value.join('');
  }
}
